import { ModuleWithProviders, NgModule } from '@angular/core';
import { NoticeService } from '@df/ui/api/notice/notice.service';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { TranslationNoticeService } from '@df/ui/translation/translation-notice.service';

@NgModule({
    imports: [TranslatePipe],
    exports: [TranslatePipe]
})
export class TranslationModule {
    static forRoot(): ModuleWithProviders<TranslationModule> {
        return {
            ngModule: TranslationModule,
            providers: [
                {
                    provide: NoticeService,
                    useExisting: TranslationNoticeService
                }
            ]
        };
    }
}
